/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-04-14 15:25:04
 * @LastEditTime: 2022-04-14 17:26:56
 * @FilePath: \insurforce-backstage-platform-side\src\views\insurance\classManage\utils.js
 */
const columns = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  scopedSlots: {
    customRender: 'index'
  },
  width: 80,
  align: 'center'
}, {
  slots: {
    title: '产品大类'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  ellipsis: true
}, {
  slots: {
    title: '排序'
  },
  dataIndex: 'sort',
  key: 'sort',
  align: 'center',
  ellipsis: true
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  key: 'status',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  },
  ellipsis: true
}, {
  slots: {
    title: '更新时间'
  },
  dataIndex: 'updateAt',
  key: 'updateAt',
  align: 'center',
  ellipsis: true
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 160,
  scopedSlots: {
    customRender: 'operation'
  }
}];
const pagination = {
  showSizeChanger: true,
  showQuickJumper: true,
  total: 0,
  pageSize: 10,
  // 每页条数
  page: 1,
  current: 1,
  showTotal: total => {
    return `共 ${total} 条`;
  },
  onShowSizeChange: (current, size) => {
    pagination.pageSize = size;
  }
};
const ADD_RULES = {
  name: [{
    required: true,
    message: '请输入产品大类',
    trigger: 'blur'
  }, {
    message: '1-50字符',
    max: 50,
    min: 1
  }],
  sort: [{
    required: true,
    message: '请输入排序数',
    trigger: 'blur'
  }]
};
const statusSelectList = [{
  key: '',
  name: '全部'
}, {
  key: 0,
  name: '已禁用'
}, {
  key: 1,
  name: '已启用'
}];
export { columns, pagination, statusSelectList, ADD_RULES };